import { useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import { BreadcrumbLine } from '../../../../../../components/BreadcrumbLine/BreadcrumbLine';
import FilterAdvanced2 from '../../../../../../components/Filter/FilterAdvanced/FilterAdvanced2';
import { getDateInput, getURLQuery, getValuesParams, setUrlByParams } from '../../../../../../helpers/helpers';
import { useLang } from '../../../../../../language';
import { TableEventos } from './TableEventos';
import queryString from 'query-string';
import { useForm } from '../../../../../../hooks/useForm';
import { ParametrosServices } from '../../../../../../services/parametros.service';
import { FilterFormHead } from './Filters/FilterFormHead';
import { FilterForm } from './Filters/FilterForm';
import { OfertasServices } from '../controllers/ofertas.service';
import { Form } from 'react-bootstrap';
import { InputText } from '../../../../../../components/Inputs';
import { ButtonSpinner } from '../../../../../../components/ButtonSpinner/ButtonSpinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

const TablonOfertas = () => {

  // Variables iniciales

  const Lang = useLang()

  const location = useLocation()

  const BreadcrumbLineItems = [
    {
      title: Lang('EVENTOS'),
      link: '/en-proceso'
    }
  ]

  const [fetchOfertasGET, fetchOfertasGETData] = OfertasServices.GET()

  const defaultValuesSearchAlways = {
    nombreevento: '',
    idestadooferta: process.env.REACT_APP_ID_ESTADO_OFERTA_ACTIVA,
    idtipoevento: '',
    fpublicacionfin: getDateInput()
  }

  const defaultValuesSearchSimple = {
    page: 1,
    limit: '',
    order: '',

  }

  const defaultValuesSearchAdvanced = {
    page: 1,
    limit: '',
    order: '',

    fechainicioinscripcion: '',
    fechafininscripcion: '',
  }

  const defaultValuesSearch = { ...defaultValuesSearchSimple, ...defaultValuesSearchAdvanced, ...defaultValuesSearchAlways }

  const params = queryString.parse(location.search);

  const [formValuesSearch, handleInputChangeSearch, handleFormChange, resetformValuesSearch] = useForm({
    page: Number(params.page) || defaultValuesSearch.page,
    limit: params.limit || defaultValuesSearch.limit,
    nombreevento: params.nombreevento || defaultValuesSearch.nombreevento,
    order: params.order || defaultValuesSearch.order,

    idtipoevento: params.idtipoevento || defaultValuesSearch.idtipoevento,

    fechainicioinscripcion: params.fechainicioinscripcion || defaultValuesSearch.fechainicioinscripcion,
    fechafininscripcion: params.fechafininscripcion || defaultValuesSearch.fechafininscripcion,
    idestadooferta: defaultValuesSearch.idestadooferta,
    fpublicacionfin: defaultValuesSearch.fpublicacionfin,
  });

  const handleSearch = (e: any, formValues: any) => {

    if (e) {
      e.preventDefault();
    }

    // Obtener todos los valores existentes en el form de values Search
    const urlParams = getValuesParams(formValues)

    // Convertir esos valores del objeto a url amigable
    // const query = getURLQuery(urlParams)

    // history.push(`?${query}`);
    // window.history.replaceState(null, '', `?${query}`);
    setUrlByParams(urlParams, 'idestadooferta', 'fpublicacionfin')

    if (formValues.page !== 1) {

      handleFormChange({
        ...formValues,
        page: 1
      });

    } else {

      let formValuesTemp = { ...formValues }

      Object.keys(formValuesTemp).forEach((k) => formValuesTemp[k] === '' && delete formValuesTemp[k]);

      fetchOfertasGET({
        params: {
          ...formValuesTemp
        }
      })
    }
  }

  useEffect(() => {

    // Obtener todos los valores existentes en el form de values Search
    const urlParams = getValuesParams(formValuesSearch)

    // Convertir esos valores del objeto a url amigable
    // const query = getURLQuery(urlParams)

    // window.history.replaceState(null, '', `?${query}`);
    setUrlByParams(urlParams, 'idestadooferta', 'fpublicacionfin')

    fetchOfertasGET({
      params: {
        ...urlParams
      }
    })


  }, [formValuesSearch.page, formValuesSearch.order, formValuesSearch.limit])


  const [fetchParamsMultiple, fetchParamsMultipleData] = ParametrosServices.GET()

  useEffect(() => {

    fetchParamsMultiple({
      params: {
        tiposeventos: true
      }
    })
  }, [])

  return (

    <div className="container-fluid">
      <div className="row">

        <div className="col-12">

          <div className="mb-4">

            <FilterAdvanced2
              handleSearch={handleSearch}
              formValuesSearch={formValuesSearch}
              handleInputChangeSearch={handleInputChangeSearch}
              fetchData={fetchOfertasGETData}
              resetformValuesSearch={resetformValuesSearch}

              defaultValuesSearchSimple={defaultValuesSearchSimple}
              defaultValuesSearchAdvanced={defaultValuesSearchAdvanced}
              defaultValuesSearchAlways={defaultValuesSearchAlways}
              handleFormChange={handleFormChange}
              simple={true}

            >

              <FilterAdvanced2.Head label={Lang('BUSCADOR')}>

                {/* <FilterFormHead fetchParamsMultipleData={fetchParamsMultipleData} /> */}
                <>
                  <Form.Group className="col-8">
                    <InputText
                      label={Lang('NOMBRE_OFERTA') + ':'}
                      name='nombreoferta'
                      value={formValuesSearch.nombreoferta}
                      size='sm'
                      onChange={handleInputChangeSearch}
                    />
                  </Form.Group>

                  <div className="col flex-grow-0 text-nowrap">
                    <div className="d-flex align-items-end justify-content-end h-100">
                      <ButtonSpinner
                        variant="secondary" type="submit" size='sm' className=""
                        handleSubmit={(e: any) => handleSearch(e, formValuesSearch)} fetchDataLoading={[fetchOfertasGETData.loading]}
                        value={Lang('BUSCAR')} icon={<FontAwesomeIcon icon={faSearch} className='me-1' />}
                      />
                    </div>

                  </div>
                </>

              </FilterAdvanced2.Head>

              <FilterAdvanced2.Body>

                {/* <FilterForm /> */}

              </FilterAdvanced2.Body>

            </FilterAdvanced2>

          </div>


          <div className=" animate__animated animate__fadeInUp">

            <TableEventos
              data={fetchOfertasGETData.data?.items}
              loading={fetchOfertasGETData.loading}
              total={fetchOfertasGETData.data?.total}
              perPage={fetchOfertasGETData.data?.per_page}

              formValuesSearch={formValuesSearch}
              handleFormChange={handleFormChange}
              handleInputChangeSearch={handleInputChangeSearch}

              urlParams={getValuesParams(formValuesSearch)}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default TablonOfertas;